var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanDisbursal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3678 21C25.8176 21 26.9928 19.8247 26.9928 18.375C26.9928 16.9253 25.8176 15.75 24.3678 15.75C22.9181 15.75 21.7428 16.9253 21.7428 18.375C21.7428 19.8247 22.9181 21 24.3678 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7828 23.1675C26.4903 22.8675 26.0178 22.8675 25.7253 23.1675L23.8278 25.065C23.5428 25.35 23.1678 25.5075 22.7703 25.5075H20.2578C19.8453 25.5075 19.5078 25.17 19.5078 24.7575C19.5078 24.345 19.8453 24.0075 20.2578 24.0075H21.7578C22.1703 24.0075 22.5078 23.67 22.5078 23.2575C22.5078 22.845 22.1703 22.5075 21.7578 22.5075H18.7578C17.9328 22.5075 17.2578 23.1825 17.2578 24.0075H15.7578C15.3453 24.0075 15.0078 24.345 15.0078 24.7575V26.2575C15.0078 26.67 15.3453 27.0075 15.7578 27.0075H22.7703C23.5728 27.0075 24.3228 26.6925 24.8928 26.13L26.7903 24.2325C27.0828 23.94 27.0828 23.4675 26.7903 23.175L26.7828 23.1675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_36"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanDisbursal);
export default __webpack_public_path__ + "static/media/loan_disbursal.04d46a75e89a4cdb42fa1883758a6f5f.svg";
export { ForwardRef as ReactComponent };